export const challengeModes = [
  { value: 1, text: 'noPreference' },
  { value: 2, text: 'challenge' },
  { value: 3, text: 'challengeMandate' },
  { value: 4, text: 'noChallenge' },
  { value: 5, text: 'noChallengeTraAcq' }
];

export const holderAuthenticationTypes = [
  { value: 1, text: 'challenge' },
  { value: 2, text: 'frictionless' },
  { value: 4, text: 'none' }
];
